import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { RemoveCatheterAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-remove-catheter-slot',
    templateUrl: './remove-catheter-slot.component.html',
    styleUrl: './remove-catheter-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoveCatheterSlotComponent implements SheetSlotComponentBase {

	@Input() action!: RemoveCatheterAction;
	value = null;

	constructor() {
	}
}